<template>
    <flex-container
        gap="lg"
        direction="column"
        align-content="stretch"
    >
        <template v-if="assistentCollection?.hasData.value">
            <template
                v-for="assistent in assistentCollection.data.value"
                :key="assistent.id.value"
            >
                <assistent-generating-card
                    v-if="assistent.isGeneratingForTheFirstTime"
                    :assistent="assistent"
                />
                <assistent-card
                    v-else
                    :assistent="assistent"
                />
            </template>
        </template>
        <template v-else-if="assistentCollection.loading">
            <assistent-card-skeleton
                v-for="i in 3"
                :key="i"
            />
        </template>
        <template v-else>
            <!-- @todo: misschien tijdelijk, overgenomen vanuit originele lister pagina -->
            <assistent-collection-empty-message />
        </template>
    </flex-container>
</template>

<script setup lang="ts">
    import { onMounted } from 'vue';
    import { Assistent } from '@keyvue/one-api-client';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import useEventBus from '@/services/eventbus/composables/useEventBus';
    import AssistentCreatedEvent from '@/ai/assistent/events/AssistentCreatedEvent';
    import AssistentDeletedEvent from '@/ai/assistent/events/AssistentDeletedEvent';
    import AssistentCollectionEmptyMessage from '@/ai/assistent/components/AssistentCollectionEmptyMessage.vue';
    import AssistentCard from '@/ai/assistent/views/AssistentDashboard/AssistentCard.vue';
    import AssistentCardSkeleton from '@/ai/assistent/views/AssistentDashboard/AssistentCardSkeleton.vue';
    import AssistentGeneratingCard from '@/ai/assistent/views/AssistentDashboard/AssistentGeneratingCard.vue';

    const { getLazyResourceCollection } = useClient();
    const assistentCollection = await getLazyResourceCollection(Assistent, {
        'order[name]': 'asc',
    });

    const eventBus = useEventBus();
    eventBus.subscribe(AssistentCreatedEvent, assistentCollection.load);
    eventBus.subscribe(AssistentDeletedEvent, assistentCollection.load);

    onMounted(async () => {
        await assistentCollection.load();
    });
</script>
